import { ChangeEvent, useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { RATING_OPTIONS, SVG_DATA, numberEmpty, numberFilled, smileyempty, smileyfilled, starempty, starfilled, smileyFivefilled, smileyFiveEmpty, smileyfullempty, smileyfullfilled, smileyTwoFilled, smileyTwoEmpty, thumbFilled, thumbEmpty, thumpnewfilled, thumpnewempty } from './constant';
import styles from "../customer_satisfaction/scss/csat.module.scss"
import TextArea from 'antd/lib/input/TextArea';
import { Radio, Checkbox, Rate, notification } from 'antd';
import { CoreServices } from '../../../../../../base/service/apiServices';
import { Navigate, useLocation, useSearchParams } from "react-router-dom";
import { customerSatisfactionAction } from '../../../../../../store/slices/customer_satisfaction_slice/customer_satisfaction-slice';
import Rating from 'react-rating';
import CryptoJS from 'crypto-js';
import { urlsplit } from '../../../../../../base/utils';
function CustomerFeedbackForm() {
    function decrypt(text: string, secretKey: string = "CSATSECRETKEY"): string {
        var bytes = CryptoJS.AES.decrypt(text, secretKey)
        return bytes.toString(CryptoJS.enc.Utf8);
    }
    const parsedUrl: any = urlsplit(window.location.href);
    const channelTypeIdParams = decrypt(parsedUrl?.channelTypeId);
    const historyIdParams = decrypt(parsedUrl?.historyId);
    const domainIdParams = decrypt(parsedUrl?.domainId);

    const customersatisfaction: any = useSelector((state: any) => state.customerSatisfaction)
    const [selectedRating, setSelectedRating] = useState(0);
    const [customersatisfactionApi, setcustomersatisfactionApi] = useState<any>();
    const [formSubmitted, setformSubmitted] = useState(false)
    const [errorState, setErrorState] = useState(false);
    const [questionErrors, setQuestionErrors] = useState([]);
    const [hoveredRating, setHoveredRating] = useState(null);
    const [questions, setQuestions] = useState<{
        questionid: string
        inputText: string;
        options: { value: string; label: string }[];
        questionOptiontype: any;
        isRequired: boolean;
        answer: string;
    }[]>([]);
    const getRatingOptions = () => {
        if ([1, 2, 3].includes(customersatisfactionApi?.ratingDesignType)) {
            return RATING_OPTIONS[1];
        } else if ([4, 5].includes(customersatisfactionApi?.ratingDesignType)) {
            return RATING_OPTIONS[2];
        } else if ([5, 6].includes(customersatisfactionApi?.ratingDesignType)) {
            return RATING_OPTIONS[3];
        }
        return [];
    };



    const ratingOptions = getRatingOptions()

    // const handleMouseLeave = () => {
    //     setHoveredRating(null); // Reset hover state when mouse leaves
    // };


    const handleSubmit = () => {
        if (validateForm()) {

            console.log('Form submitted');
        } else {
            return
        }


        const body = {
            customerFeedbackId: customersatisfactionApi?.customerFeedbackId,
            historyId: historyIdParams,
            channelTypeId: channelTypeIdParams,
            satisfactionRate: selectedRating ?? 0,
            feedbackQuestionAnswer: JSON.stringify(questions) ?? null,
            domainId: domainIdParams,
            AgentId:customersatisfactionApi?.AgentId ?? null,
            ratingType:customersatisfactionApi?.ratingType ?? null,
            sessionId: null,

        }


        CoreServices.post(body, `/insert_update_customer_feedback`)
            .then((response: any) => {
                if (response && response.data.statusCode === 200) {

                    let response_data: any = [response.data.insertResult]

                    setformSubmitted(true)
                }
            })
            .catch((err) => {
                console.log(err, "insert_customer_satisfication");
                notification.info({
                    message: "network error",
                    placement: "top",
                    className: "toastNotification error",
                    icon: <span className="icon__Error24" />,
                    closeIcon: <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                        <path d="M5.80082 4.99937L9.70415 1.09571C9.92548 0.874973 9.92548 0.51564 9.70415 0.294906C9.48282 0.0735729 9.12342 0.0735729 8.90335 0.294906L5.00002 4.19851L1.09668 0.294906C0.876616 0.0735729 0.515949 0.0735729 0.295883 0.294906C0.0745495 0.51564 0.0745495 0.874973 0.295883 1.09571L4.19922 4.99937L0.295883 8.90304C0.0745495 9.12377 0.0745495 9.48311 0.295883 9.70384C0.406549 9.81451 0.551083 9.86984 0.696283 9.86984C0.841483 9.86984 0.986616 9.81451 1.09668 9.70384L5.00002 5.80024L8.90335 9.70384C9.01335 9.81451 9.15855 9.86984 9.30375 9.86984C9.44895 9.86984 9.59348 9.81451 9.70415 9.70384C9.92548 9.48311 9.92548 9.12377 9.70415 8.90304L5.80082 4.99937Z" fill="#757676" />
                    </svg>,
                    duration: 3,
                    top: 70,
                });
            })
    };
    const handleCancel = () => {
        window.close();
    }
    // const validateForm = () => {
    //     let hasError = false;
    
    //     // Common check for rating selection
    //     if (!selectedRating) {
    //         setErrorState(true);
    //         hasError = true;
    //     }
    
    //     if (customersatisfactionApi?.additionalQuestionType === 1 || customersatisfactionApi?.additionalQuestionType === 2) {
    //         const errors = questions.map((question) => {
    //             // Trim the answer during validation
    //             if (question.isRequired && (!question.answer || question.answer.trim() === '')) {
    //                 return true;
    //             }
    //             return false;
    //         });
    
    //         setQuestionErrors(errors);
    
    //         if (errors.some(Boolean)) {
    //             hasError = true;
    //         }
    //     }
    
    //     return !hasError;
    // };
    
    const validateForm = () => {
        let hasError = false;

        if (!selectedRating) {
            setErrorState(true);
            hasError = true;
        }


        if (customersatisfactionApi?.additionalQuestionType === 1) {
            const errors = questions.map((question) => {
                if (question.isRequired && !question.answer) {
                    return true;
                }
                return false;
            });

            setQuestionErrors(errors);

            if (errors.some(Boolean)) {
                hasError = true;
            }
        }
        if (customersatisfactionApi?.additionalQuestionType === 2) {
            if (
                ([1, 2, 3].includes(customersatisfactionApi?.ratingDesignType) && selectedRating > 0 && selectedRating <= 3) ||
                ([4, 5].includes(customersatisfactionApi?.ratingDesignType) && selectedRating > 0 && selectedRating <= 2) ||
                ([5, 6].includes(customersatisfactionApi?.ratingDesignType) && selectedRating > 0 && selectedRating <= 1)
            ) {
                const errors = questions.map((question) => {
                    if (question.isRequired && !question.answer) {
                        return true;
                    }
                    return false;
                });

                setQuestionErrors(errors);

                if (errors.some(Boolean)) {
                    hasError = true;
                }
            }
        }

        return !hasError;
    };

    const handleClick = (index: any) => {
        setSelectedRating(index);
        setErrorState(false);
    };



    const handleHover = (rate: any) => {
        setHoveredRating(rate);
    };

    const getCsat = async () => {
        try {
            let body = {
                historyId: historyIdParams,
                channelTypeId: channelTypeIdParams,
                domainId: domainIdParams,
            }
            const response = await CoreServices.post(body, `/get_customer_satisfication_channel`);

            if (response && response.data.statusCode === 200) {
                const data = response.data.insertResult;
                const customersatisfactionApiData = data.length > 0 ? data[0] : null;
                const question = JSON.parse(customersatisfactionApiData?.additionalQuestions ?? '[]') ?? [];
                setcustomersatisfactionApi(customersatisfactionApiData)
                setQuestions(question);
            } else {
                console.error("Error: Unexpected status code or response format.");
            }
        } catch (error) {
            console.error("Error fetching customer satisfaction rating:", error);
        }
    };


    useEffect(() => {
        getCsat()
    }, [])
    const handleTextChange = (e: any, index: number) => {
        const newQuestions = [...questions];
        const value = e.target.value;
        if (value.length === 1 && value === ' ') {
            return;
        }
    
        newQuestions[index].answer = value;
        setQuestions(newQuestions);
    };
    const handleRadioChange = (e: any, index: number, optionLabel: string) => {
        const newQuestions = [...questions];
        newQuestions[index].answer = optionLabel;
        setQuestions(newQuestions);
    };
    const handleCheckboxChange = (e: any, index: number, optionLabel: string) => {
        const newQuestions = [...questions];
        const selectedLabels = newQuestions[index].answer ? newQuestions[index].answer.split(',') : [];

        if (e.target.checked) {
            selectedLabels.push(optionLabel);
        } else {
            const labelIndex = selectedLabels.indexOf(optionLabel);
            if (labelIndex > -1) {
                selectedLabels.splice(labelIndex, 1);
            }
        }

        newQuestions[index].answer = selectedLabels.join(', ');
        setQuestions(newQuestions);
    };


    const getIcons = (type: any) => {

        switch (type) {
            case 1:
                return { full: starfilled, empty: starempty };
            case 2:
                return { full: numberFilled, empty: numberEmpty };
            case 3:
                return { full: smileyfullfilled, empty: smileyfullempty };
            case 4:
                return { full: smileyfilled, empty: smileyempty };
            case 5:
                return { full: thumpnewfilled, empty: thumpnewempty };
            case 6:
                return { full: smileyTwoFilled, empty: smileyTwoEmpty };
            case 7:
                return { full: thumbFilled, empty: thumbEmpty };
            default:
                return { full: [], empty: [] };
        }
    };
    const icons = getIcons(customersatisfactionApi?.ratingDesignType);


    return (
        <>

            <div className={styles.maincontaineremailcom}>
                <div className={styles.worktualheadersec}>
                    <div className={styles.mintgreensec}></div>
                    <div className={styles.header}>
                        <div className={styles.logocont}>
                            <svg width="173" height="40" viewBox="0 0 173 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M39.5866 7.23311V26.5272H26.4594V20.5673C26.4594 16.5752 23.2706 13.3357 19.3394 13.3357H13.4727V0H32.4665C36.3978 0 39.5866 3.23789 39.5866 7.23311Z" fill="#e6e4eb" />
                                <path d="M26.461 26.5234V39.7086L13.4805 26.5234H26.461Z" fill="#e6e4eb" />
                                <path d="M26.4596 20.5675C26.4596 16.5738 23.2723 13.3359 19.3411 13.3359H13.4744L13.479 13.3406H0.5V26.5258H13.479V13.3422L26.458 26.5274V20.5675H26.4596Z" fill="white" />
                                <path d="M71.3902 8.23438L68.118 20.2263L65.0913 8.67028H59.8142L56.7875 20.2263L53.4536 8.23438H48.0098L54.3395 31.2242H58.3757L62.452 19.3875L66.4974 31.2242H70.5644L76.8942 8.23438H71.3902ZM82.2377 15.4424C77.8944 15.4424 74.3475 19.0456 74.3475 23.4579C74.3475 27.8703 77.8944 31.4735 82.2377 31.4735C86.581 31.4735 90.1279 27.8703 90.1279 23.4579C90.1279 19.0456 86.581 15.4424 82.2377 15.4424ZM82.2377 26.4402C80.617 26.4402 79.302 25.1043 79.302 23.4579C79.302 21.8116 80.617 20.4756 82.2377 20.4756C83.8583 20.4756 85.1733 21.8116 85.1733 23.4579C85.1733 25.1043 83.8583 26.4402 82.2377 26.4402ZM123.754 10.751H118.799V24.6684C118.799 29.2046 121.062 31.2226 125.007 31.2226H127.912V26.1894H125.16C124.303 26.1894 123.754 25.5684 123.754 24.7296V20.0695H128.097V15.6886H123.754V10.7494V10.751ZM162.378 15.6901H158.218V16.4051C157.056 15.7827 155.833 15.4408 154.487 15.4408C150.146 15.4408 146.63 19.0127 146.63 23.425C146.63 27.8373 150.146 31.4719 154.487 31.4719C155.893 31.4719 157.117 31.0674 158.28 30.4762V31.2226H163.338V26.6723H162.378V15.6901ZM154.608 26.4387C152.989 26.4387 151.703 25.1028 151.703 23.425C151.703 21.7473 152.987 20.4411 154.608 20.4411C156.228 20.4411 157.545 21.7771 157.545 23.425C157.545 25.073 156.23 26.4387 154.608 26.4387ZM171.461 26.1894C170.726 26.1894 170.359 25.6923 170.359 24.9773V9.47779H164.446V14.0281H165.406V24.9162C165.406 29.2971 166.965 31.2226 171.308 31.2226H172.5V26.1894H171.459H171.461ZM95.4574 16.4036V15.6886H90.7067V20.2389H91.6667V31.221H96.5595V22.2741C96.5595 21.2502 97.3868 20.4411 98.3947 20.4411H100.412V15.6886H98.211C97.2618 15.6886 96.3449 15.8438 95.4574 16.4036ZM117.264 15.6886H111.392L107.212 19.8202V9.47779H101.301V14.0281H102.259V31.2226H107.214V26.7805L108.176 25.8334L112.036 31.2226H118.029L111.485 22.4623L117.264 15.6901V15.6886ZM140.022 24.6041C140.022 25.6296 139.196 26.4685 138.187 26.4685C137.177 26.4685 136.353 25.628 136.353 24.6041V15.6886H130.468V20.2389H131.431V24.6041C131.431 28.394 134.458 31.4703 138.188 31.4703C141.919 31.4703 144.947 28.394 144.947 24.6041V15.6886H140.023V24.6041H140.022Z" fill="white" />
                            </svg></div>
                    </div>

                </div>
                <div className={styles.maincontaineremailconinner}>
                    {formSubmitted == false && customersatisfactionApi?.errCode === 1 && <>
                        <div className={styles.scrollerdiv}>

                            <div className={styles.starsec}  >
                                <div className={styles.starsecblock}>
                                    <p className={styles.shareexptxt}>Share your experience</p>
                                    <div className={`${styles.starboxcontainer}  ${errorState ? `${styles.errorstate} ` : ''}`}>
                                        <p className={styles.starboxsubp}>Please rate your satisfaction with us</p>


                                        <div style={{ display: "flex", flexDirection: "column", gap: "12px", justifyContent: "center", alignItems: "center" }}>
                                            <Rating

                                                stop={icons.full.length}
                                                emptySymbol={icons.empty}
                                                fullSymbol={icons.full}
                                                className="ratingshow"
                                                onChange={handleClick}
                                                onHover={handleHover}
                                                // onMouseLeave={handleMouseLeave} 
                                                initialRating={selectedRating}
                                            />

                                            {hoveredRating !== null ? (
                                                <div className="hover-label">
                                                    <span className={styles.ratinglabeltxt}>
                                                        {ratingOptions[hoveredRating - 1]}
                                                    </span>
                                                </div>
                                            ) : (
                                                <div className="hover-label">
                                                    <p>&nbsp;</p> {/* Adding a non-breaking space to maintain height/spacing */}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {(customersatisfactionApi?.additionalQuestionType === 1) ||
                                (customersatisfactionApi?.additionalQuestionType === 2 && (
                                    (
                                        [1, 2, 3].includes(customersatisfactionApi?.ratingDesignType)
                                        && selectedRating > 0
                                        && selectedRating <= 3
                                    ) || (
                                        [4, 5].includes(customersatisfactionApi?.ratingDesignType)
                                        && selectedRating > 0
                                        && selectedRating <= 2
                                    ) || (
                                        [5, 6].includes(customersatisfactionApi?.ratingDesignType)
                                        && selectedRating > 0
                                        && selectedRating <= 1
                                    )
                                )
                                )
                                ?

                                <div className={styles.ansblock}>

                                    {questions && questions.map((question, index) => (
                                        <div key={index} className={styles.ratingformblock}>
                                            <div className={styles.ansblock}>
                                                <p className={styles.qndivqn}>
                                                    {index + 1}.{question?.inputText}{question?.isRequired && <span className="reqStart">*</span>}
                                                </p>
                                            </div>

                                            {/* Text area question */}
                                            {question?.inputText?.length > 0 && question?.questionOptiontype === 1 && (
                                                <>
                                                    <TextArea
                                                        value={question.answer}
                                                        onChange={(e) => handleTextChange(e, index)}
                                                        className={styles.textarea}
                                                    />
                                                    {/* Error message if required and no answer */}
                                                    {questionErrors[index] && <p className={styles.errortxtmsg}>Please answer the question</p>}
                                                </>
                                            )}

                                            {/* Radio question */}
                                            {question?.inputText?.length > 0 && question?.questionOptiontype === 2 && (
                                                <div>
                                                    {question?.options?.map((option, optionIndex) => (
                                                        <div className={styles.radioinppreviewcont} key={optionIndex}>
                                                            <Radio
                                                                type="radio"
                                                                name={`question-${index}`}
                                                                value={option.value}
                                                                checked={question.answer === option.label}
                                                                onChange={(e) => handleRadioChange(e, index, option.label)}
                                                            />
                                                            <label>{option.label}</label>
                                                        </div>
                                                    ))}
                                                    {/* Error message if required and no answer */}
                                                    {questionErrors[index] && <p className={styles.errortxtmsg}>Please answer the question</p>}
                                                </div>
                                            )}

                                            {/* Checkbox question */}
                                            {question?.inputText?.length > 0 && question?.questionOptiontype === 3 && (
                                                <div>
                                                    {question?.options?.map((option, optionIndex) => (
                                                        <div className={styles.radioinppreviewcont} key={optionIndex}>
                                                            <Checkbox
                                                                type="checkbox"
                                                                name={`question-${index}`}
                                                                value={option.value}
                                                                checked={question.answer?.includes(option.label) || false}
                                                                onChange={(e) => handleCheckboxChange(e, index, option.label)}
                                                            />
                                                            <label>{option.label}</label>
                                                        </div>
                                                    ))}
                                                    {/* Error message if required and no answer */}
                                                    {questionErrors[index] && <p className={styles.errortxtmsg}>Please answer the question</p>}
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                </div> : ""}
                        </div></>}
                    {customersatisfactionApi?.errCode == "0" || formSubmitted == true ?
                        <div>
                            {customersatisfactionApi?.thanksNote}
                        </div> : ""}

                    {formSubmitted == false && customersatisfactionApi?.errCode == "1" && <>
                        <div className={styles.footerendsec}>
                            <div className={styles.btnsec}>
                                {/* <button className={styles.cancelbtn} onClick={handleCancel}>Cancel</button> */}
                                <button className={styles.savebtn} onClick={handleSubmit}>Submit</button>
                            </div>

                            <div className={styles.poweredsec}>
                                <span><svg width="100%" height="31" viewBox="0 0 701 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M282.387 16.7266V9.45384H284.844C285.414 9.45384 285.881 9.55682 286.243 9.76278C286.608 9.96638 286.878 10.2422 287.053 10.5902C287.228 10.9382 287.316 11.3265 287.316 11.755C287.316 12.1835 287.228 12.5729 287.053 12.9233C286.88 13.2737 286.612 13.553 286.25 13.7614C285.888 13.9673 285.424 14.0703 284.858 14.0703H283.097V13.2891H284.83C285.22 13.2891 285.534 13.2216 285.771 13.0866C286.008 12.9517 286.179 12.7694 286.286 12.5398C286.395 12.3078 286.449 12.0462 286.449 11.755C286.449 11.4638 286.395 11.2034 286.286 10.9737C286.179 10.7441 286.006 10.5642 285.767 10.4339C285.528 10.3014 285.211 10.2351 284.816 10.2351H283.267V16.7266H282.387ZM290.778 16.8402C290.285 16.8402 289.853 16.723 289.482 16.4886C289.112 16.2543 288.824 15.9264 288.615 15.505C288.409 15.0836 288.306 14.5911 288.306 14.0277C288.306 13.4595 288.409 12.9635 288.615 12.5398C288.824 12.116 289.112 11.7869 289.482 11.5526C289.853 11.3182 290.285 11.201 290.778 11.201C291.27 11.201 291.701 11.3182 292.07 11.5526C292.442 11.7869 292.731 12.116 292.937 12.5398C293.145 12.9635 293.249 13.4595 293.249 14.0277C293.249 14.5911 293.145 15.0836 292.937 15.505C292.731 15.9264 292.442 16.2543 292.07 16.4886C291.701 16.723 291.27 16.8402 290.778 16.8402ZM290.778 16.0874C291.152 16.0874 291.46 15.9915 291.701 15.7997C291.943 15.608 292.121 15.3558 292.237 15.0433C292.353 14.7308 292.411 14.3923 292.411 14.0277C292.411 13.6631 292.353 13.3234 292.237 13.0085C292.121 12.6937 291.943 12.4392 291.701 12.245C291.46 12.0509 291.152 11.9538 290.778 11.9538C290.404 11.9538 290.096 12.0509 289.855 12.245C289.613 12.4392 289.434 12.6937 289.318 13.0085C289.202 13.3234 289.144 13.6631 289.144 14.0277C289.144 14.3923 289.202 14.7308 289.318 15.0433C289.434 15.3558 289.613 15.608 289.855 15.7997C290.096 15.9915 290.404 16.0874 290.778 16.0874ZM295.579 16.7266L293.917 11.272H294.798L295.977 15.4482H296.034L297.198 11.272H298.093L299.244 15.4339H299.301L300.48 11.272H301.36L299.698 16.7266H298.874L297.681 12.5362H297.596L296.403 16.7266H295.579ZM304.57 16.8402C304.044 16.8402 303.591 16.7242 303.21 16.4922C302.831 16.2578 302.538 15.9311 302.332 15.5121C302.129 15.0907 302.027 14.6006 302.027 14.0419C302.027 13.4832 302.129 12.9908 302.332 12.5646C302.538 12.1361 302.825 11.8023 303.192 11.5632C303.561 11.3217 303.992 11.201 304.484 11.201C304.768 11.201 305.049 11.2483 305.326 11.343C305.603 11.4377 305.855 11.5916 306.082 11.8047C306.31 12.0154 306.491 12.2947 306.626 12.6428C306.761 12.9908 306.828 13.4193 306.828 13.9283V14.2834H302.624V13.5589H305.976C305.976 13.2512 305.914 12.9766 305.791 12.7351C305.67 12.4936 305.498 12.303 305.273 12.1634C305.05 12.0237 304.787 11.9538 304.484 11.9538C304.151 11.9538 303.862 12.0367 303.618 12.2024C303.376 12.3658 303.191 12.5788 303.06 12.8416C302.93 13.1044 302.865 13.3861 302.865 13.6868V14.1697C302.865 14.5817 302.936 14.9309 303.078 15.2173C303.223 15.5014 303.423 15.718 303.678 15.8672C303.934 16.014 304.231 16.0874 304.57 16.0874C304.79 16.0874 304.989 16.0566 305.166 15.995C305.346 15.9311 305.501 15.8364 305.631 15.7109C305.762 15.5831 305.862 15.4245 305.933 15.2351L306.743 15.4624C306.658 15.737 306.514 15.9785 306.313 16.1868C306.112 16.3928 305.863 16.5537 305.567 16.6697C305.272 16.7834 304.939 16.8402 304.57 16.8402ZM308.103 16.7266V11.272H308.913V12.0959H308.969C309.069 11.826 309.249 11.607 309.509 11.4389C309.77 11.2708 310.063 11.1868 310.39 11.1868C310.451 11.1868 310.528 11.188 310.621 11.1903C310.713 11.1927 310.783 11.1963 310.83 11.201V12.0533C310.802 12.0462 310.737 12.0355 310.635 12.0213C310.536 12.0047 310.43 11.9964 310.319 11.9964C310.054 11.9964 309.817 12.0521 309.609 12.1634C309.403 12.2723 309.239 12.4238 309.119 12.6179C309 12.8097 308.941 13.0286 308.941 13.2749V16.7266H308.103ZM313.945 16.8402C313.419 16.8402 312.966 16.7242 312.585 16.4922C312.206 16.2578 311.913 15.9311 311.707 15.5121C311.504 15.0907 311.402 14.6006 311.402 14.0419C311.402 13.4832 311.504 12.9908 311.707 12.5646C311.913 12.1361 312.2 11.8023 312.567 11.5632C312.936 11.3217 313.367 11.201 313.859 11.201C314.143 11.201 314.424 11.2483 314.701 11.343C314.978 11.4377 315.23 11.5916 315.457 11.8047C315.685 12.0154 315.866 12.2947 316.001 12.6428C316.136 12.9908 316.203 13.4193 316.203 13.9283V14.2834H311.999V13.5589H315.351C315.351 13.2512 315.289 12.9766 315.166 12.7351C315.045 12.4936 314.873 12.303 314.648 12.1634C314.425 12.0237 314.162 11.9538 313.859 11.9538C313.526 11.9538 313.237 12.0367 312.993 12.2024C312.751 12.3658 312.566 12.5788 312.435 12.8416C312.305 13.1044 312.24 13.3861 312.24 13.6868V14.1697C312.24 14.5817 312.311 14.9309 312.453 15.2173C312.598 15.5014 312.798 15.718 313.053 15.8672C313.309 16.014 313.606 16.0874 313.945 16.0874C314.165 16.0874 314.364 16.0566 314.541 15.995C314.721 15.9311 314.876 15.8364 315.006 15.7109C315.137 15.5831 315.237 15.4245 315.308 15.2351L316.118 15.4624C316.033 15.737 315.889 15.9785 315.688 16.1868C315.487 16.3928 315.238 16.5537 314.942 16.6697C314.647 16.7834 314.314 16.8402 313.945 16.8402ZM319.538 16.8402C319.083 16.8402 318.682 16.7254 318.334 16.4957C317.986 16.2637 317.714 15.937 317.517 15.5156C317.321 15.0919 317.222 14.5911 317.222 14.0135C317.222 13.4406 317.321 12.9434 317.517 12.522C317.714 12.1006 317.987 11.7751 318.337 11.5455C318.688 11.3158 319.093 11.201 319.552 11.201C319.907 11.201 320.188 11.2602 320.393 11.3786C320.602 11.4946 320.76 11.6271 320.869 11.7763C320.981 11.9231 321.067 12.0438 321.129 12.1385H321.2V9.45384H322.038V16.7266H321.228V15.8885H321.129C321.067 15.9879 320.979 16.1134 320.866 16.2649C320.752 16.4141 320.59 16.5478 320.379 16.6662C320.169 16.7822 319.888 16.8402 319.538 16.8402ZM319.651 16.0874C319.987 16.0874 320.272 15.9998 320.504 15.8246C320.736 15.647 320.912 15.402 321.033 15.0895C321.153 14.7746 321.214 14.4112 321.214 13.9993C321.214 13.5921 321.155 13.2358 321.036 12.9304C320.918 12.6226 320.743 12.3835 320.511 12.2131C320.279 12.0402 319.992 11.9538 319.651 11.9538C319.296 11.9538 319 12.045 318.763 12.2273C318.529 12.4072 318.353 12.6522 318.234 12.9624C318.118 13.2701 318.06 13.6158 318.06 13.9993C318.06 14.3875 318.12 14.7403 318.238 15.0575C318.359 15.3724 318.536 15.6233 318.771 15.8104C319.007 15.995 319.301 16.0874 319.651 16.0874ZM326.615 16.7266V9.45384H327.453V12.1385H327.524C327.586 12.0438 327.671 11.9231 327.78 11.7763C327.891 11.6271 328.05 11.4946 328.256 11.3786C328.464 11.2602 328.746 11.201 329.101 11.201C329.56 11.201 329.965 11.3158 330.315 11.5455C330.666 11.7751 330.939 12.1006 331.136 12.522C331.332 12.9434 331.43 13.4406 331.43 14.0135C331.43 14.5911 331.332 15.0919 331.136 15.5156C330.939 15.937 330.667 16.2637 330.319 16.4957C329.971 16.7254 329.57 16.8402 329.115 16.8402C328.765 16.8402 328.484 16.7822 328.273 16.6662C328.063 16.5478 327.901 16.4141 327.787 16.2649C327.673 16.1134 327.586 15.9879 327.524 15.8885H327.425V16.7266H326.615ZM327.439 13.9993C327.439 14.4112 327.499 14.7746 327.62 15.0895C327.741 15.402 327.917 15.647 328.149 15.8246C328.381 15.9998 328.665 16.0874 329.001 16.0874C329.352 16.0874 329.644 15.995 329.879 15.8104C330.115 15.6233 330.293 15.3724 330.411 15.0575C330.532 14.7403 330.592 14.3875 330.592 13.9993C330.592 13.6158 330.533 13.2701 330.415 12.9624C330.299 12.6522 330.122 12.4072 329.886 12.2273C329.651 12.045 329.357 11.9538 329.001 11.9538C328.661 11.9538 328.374 12.0402 328.142 12.2131C327.91 12.3835 327.735 12.6226 327.616 12.9304C327.498 13.2358 327.439 13.5921 327.439 13.9993ZM333.057 18.772C332.915 18.772 332.788 18.7602 332.677 18.7365C332.566 18.7152 332.489 18.6939 332.446 18.6726L332.659 17.9339C332.863 17.986 333.043 18.005 333.199 17.9908C333.355 17.9766 333.494 17.9067 333.614 17.7812C333.737 17.6581 333.85 17.4581 333.952 17.1811L334.108 16.755L332.091 11.272H333L334.506 15.6186H334.562L336.068 11.272H336.977L334.662 17.522C334.558 17.8037 334.429 18.0369 334.275 18.2216C334.121 18.4086 333.942 18.5471 333.739 18.6371C333.537 18.727 333.31 18.772 333.057 18.772Z" fill="#757676" />
                                    <path d="M355.494 8.90271V14.7492H351.467V12.9432C351.467 11.7335 350.489 10.7519 349.284 10.7519H347.484V6.71094H353.31C354.516 6.71094 355.494 7.69208 355.494 8.90271Z" fill="#00E79F" />
                                    <path d="M351.467 14.75V18.7454L347.486 14.75H351.467Z" fill="#00E79F" />
                                    <path d="M351.468 12.9413C351.468 11.7311 350.49 10.75 349.284 10.75H347.485L347.487 10.7514H343.506V14.7468H347.487V10.7519L351.467 14.7473V12.9413H351.468Z" fill="#161717" />
                                    <path d="M370.763 7.22656L369.186 12.9028L367.727 7.43289H365.183L363.725 12.9028L362.118 7.22656H359.494L362.545 18.1086H364.49L366.455 12.5058L368.405 18.1086H370.365L373.415 7.22656H370.763ZM375.991 10.6384C373.898 10.6384 372.188 12.344 372.188 14.4325C372.188 16.521 373.898 18.2266 375.991 18.2266C378.084 18.2266 379.794 16.521 379.794 14.4325C379.794 12.344 378.084 10.6384 375.991 10.6384ZM375.991 15.8441C375.21 15.8441 374.576 15.2118 374.576 14.4325C374.576 13.6532 375.21 13.0208 375.991 13.0208C376.772 13.0208 377.406 13.6532 377.406 14.4325C377.406 15.2118 376.772 15.8441 375.991 15.8441ZM396 8.41778H393.612V15.0055C393.612 17.1526 394.703 18.1078 396.604 18.1078H398.004V15.7254H396.678C396.265 15.7254 396 15.4315 396 15.0344V12.8286H398.094V10.7549H396V8.41778ZM414.616 10.7557H412.611V11.0941C412.051 10.7995 411.462 10.6377 410.813 10.6377C408.72 10.6377 407.026 12.3284 407.026 14.4169C407.026 16.5054 408.72 18.2258 410.813 18.2258C411.491 18.2258 412.08 18.0343 412.641 17.7545V18.1078H415.078V15.954H414.616V10.7557ZM410.871 15.8434C410.091 15.8434 409.471 15.211 409.471 14.4169C409.471 13.6228 410.09 13.0045 410.871 13.0045C411.652 13.0045 412.286 13.6369 412.286 14.4169C412.286 15.1969 411.653 15.8434 410.871 15.8434ZM418.993 15.7254C418.639 15.7254 418.462 15.4901 418.462 15.1517V7.81512H415.612V9.96896H416.075V15.1227C416.075 17.1964 416.827 18.1078 418.92 18.1078H419.494V15.7254H418.993ZM382.362 11.0934V10.7549H380.073V12.9088H380.535V18.1071H382.894V13.8721C382.894 13.3875 383.292 13.0045 383.778 13.0045H384.75V10.7549H383.689C383.232 10.7549 382.79 10.8284 382.362 11.0934ZM392.872 10.7549H390.042L388.028 12.7106V7.81512H385.179V9.96896H385.641V18.1078H388.029V16.0052L388.492 15.5569L390.353 18.1078H393.241L390.087 13.9612L392.872 10.7549ZM403.841 14.975C403.841 15.4604 403.443 15.8575 402.956 15.8575C402.47 15.8575 402.073 15.4597 402.073 14.975V10.7549H399.236V12.9088H399.7V14.975C399.7 16.7689 401.159 18.2251 402.957 18.2251C404.755 18.2251 406.215 16.7689 406.215 14.975V10.7549H403.842L403.841 14.975Z" fill="black" />
                                </svg></span>
                            </div>
                        </div></>}
                </div>
            </div>
        </>
    )
}










export default CustomerFeedbackForm